<template>
  <div class="login-wrap">
    <!-- 全屏背景渐变 -->
    <div class="bg-gradient"></div>
    
    <!-- 光晕效果 -->
    <div class="glow-center"></div>
    <div class="glow-right"></div>
    <div class="glow-1"></div>
    <div class="glow-2"></div>
    <div class="glow-3"></div>
    
    <!-- 放射光线 -->
    <div class="ray ray-1"></div>
    <div class="ray ray-2"></div>
    <div class="ray ray-3"></div>
    
    <!-- 装饰圆点 -->
    <div class="dot dot-1"></div>
    <div class="dot dot-2"></div>
    <div class="dot dot-3"></div>
    <div class="dot dot-4"></div>
    <div class="dot dot-5"></div>
    <div class="dot dot-6"></div>
    
    <!-- 底部波浪 -->
    <svg class="wave wave-1" viewBox="0 0 1440 200" preserveAspectRatio="none">
      <path d="M0,100 C240,150 480,50 720,100 C960,150 1200,50 1440,100 L1440,200 L0,200 Z" fill="rgba(255,255,255,0.09)"/>
    </svg>
    <svg class="wave wave-2" viewBox="0 0 1440 150" preserveAspectRatio="none">
      <path d="M0,75 C360,120 720,30 1080,75 C1200,90 1320,60 1440,75 L1440,150 L0,150 Z" fill="rgba(255,255,255,0.07)"/>
    </svg>
    <svg class="wave wave-3" viewBox="0 0 1440 80" preserveAspectRatio="none">
      <path d="M0,40 C480,60 960,20 1440,40 L1440,80 L0,80 Z" fill="rgba(255,255,255,0.05)"/>
    </svg>
    <svg class="wave wave-4" viewBox="0 0 1440 40" preserveAspectRatio="none">
      <path d="M0,20 C360,30 1080,10 1440,20 L1440,40 L0,40 Z" fill="rgba(255,255,255,0.03)"/>
    </svg>
    
    <!-- 内容容器 -->
    <div class="content-container">
      <!-- 左侧品牌区 -->
      <div class="left-brand">
        <!-- Logo -->
        <div class="logo-row">
          <img src="../../assets/main/white_logo.png" alt="Logo" class="logo-img" />
          <span class="logo-text">智慧养老</span>
        </div>
        
        <!-- 标题区 -->
        <div class="title-block">
          <h1 class="main-title">智慧养老管理平台</h1>
          <p class="tagline">专业 · 智能 · 关怀</p>
          <p class="desc">为养老机构提供全方位数字化管理解决方案</p>
        </div>
        
        <!-- 功能标签 -->
        <div class="pill-row">
          <div class="pill">
            <i class="el-icon-data-analysis"></i>
            <span>实时监控</span>
          </div>
          <div class="pill">
            <i class="el-icon-bell"></i>
            <span>智能预警</span>
          </div>
          <div class="pill">
            <i class="el-icon-circle-check"></i>
            <span>安全可靠</span>
          </div>
        </div>
      </div>
      
      <!-- 右侧登录卡片 -->
      <div class="right-login">
        <div class="login-card">
          <!-- 卡片顶部光晕 -->
          <div class="card-glow"></div>
          
          <!-- 卡片头部 -->
          <div class="card-header">
            <img src="../../assets/login/lehuo_icon.png" alt="Logo" class="card-logo-img" />
            <h2 class="card-title">欢迎登录</h2>
            <p class="card-subtitle">智慧养老管理平台</p>
          </div>
          
          <!-- 登录表单 -->
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            class="login-form"
          >
            <!-- 用户名 -->
            <el-form-item prop="account">
              <el-input
                v-model="ruleForm2.account"
                placeholder="请输入用户名"
                prefix-icon="el-icon-user"
                id="lhAccount"
                name="lhAccount"
                autocomplete="lhAccount"
              ></el-input>
            </el-form-item>
            
            <!-- 密码 -->
            <el-form-item prop="checkPass">
              <el-input
                v-model="ruleForm2.checkPass"
                :type="passwordEye"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                show-password
              ></el-input>
            </el-form-item>
            
            <!-- 验证码 -->
            <el-form-item prop="code">
              <div class="code-row">
                <el-input
                  v-model="ruleForm2.code"
                  placeholder="验证码"
                  class="code-input"
                ></el-input>
                <identify-code 
                  :identifyCode="identifyCode"
                  @refresh="refreshCode"
                ></identify-code>
              </div>
            </el-form-item>
            
            <!-- 登录按钮 -->
            <el-form-item class="login-btn-item">
              <el-button
                type="primary"
                class="login-btn"
                :loading="logining"
                @click.native.prevent="handleSubmit"
                @keyup.enter.native.prevent="enterLogin(ruleForm2)"
              >
                登 录
              </el-button>
            </el-form-item>
          </el-form>
          
          <!-- 底部版权 -->
          <div class="card-footer">
            <p>© 2025 智慧养老管理平台</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IdentifyCode from "../../components/child/IdentifyCode";
export default {
  data() {
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (value == "0000") {
        callback();
      } else if (value !== this.identifyCode) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      check: "",
      PasswordEyeDiv: false,
      passwordEye: "password",
      eyeShowPassword: true,
      identifyCodes: "1234567890",
      identifyCode: "",
      groupCode:'',
      login: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "110% 100%",
        width: "100%",
        height: "100%",
      },
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
        code: "",
        accountEdit: "",
        oldPassEdit: "",
        newPassEdit: "",
      },
      rules2: {
        account: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      checked: true,
      readonlyAccount: true,
      readonlycheckPass: true,
    };
  },
  methods: {
    handleSubmit(ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
          };
          this.$postLogin("uac/auth/form", loginParams)
            .then((response) => {
              window.sessionStorage.setItem(
                "Authorization","Bearer " + response.access_token);
              window.sessionStorage.setItem("username", loginParams.username);
              window.sessionStorage.setItem("password", loginParams.password);
              localStorage.setItem('username', loginParams.username);
              localStorage.setItem('password', loginParams.password);
              sessionStorage.setItem(
                "user",
                JSON.stringify(this.ruleForm2.account)
              );
              this.getUserData();
            })
            .catch((error) => {
              this.logining = false;
              if (error.code == 500) {
                this.$message({
                  type: "error",
                  message: error.message,
                });
              }
              this.identifyCode = "";
              this.makeCode(this.identifyCodes, 4);
            });
        } else {
          return false;
        }
      });
    },
    enterLogin(ruleForm2) {
      this.handleSubmit();
    },
    focusAccount() {
      this.PasswordEyeDiv = false;
      this.readonlyAccount = false;
    },
    focusShowPasswordEye() {
      this.PasswordEyeDiv = true;
      this.readonlycheckPass = false;
    },
    focusCode() {
      this.PasswordEyeDiv = false;
    },
    changePassword(value) {
      if (value == "show") {
        this.passwordEye = "text";
        this.eyeShowPassword = false;
      } else {
        this.passwordEye = "password";
        this.eyeShowPassword = true;
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    getUserData() {
      this.$postForm("uac/user/getInformation", {}).then((response) => {
            this.logining = false;
            sessionStorage.setItem("groupId", response.result.groupId); 
            sessionStorage.setItem("groupType", response.result.groupType); 
            sessionStorage.setItem("roleCode", response.result.role); 
            if(response.result.role == "street" || response.result.role == "community" ){
              this.$message({
                type: "error",
                message: "暂无权限登录",
              });
              return;
            }
            if(response.result.groupType == "9"){
              this.$router.push('/bigView');
              this.$message({
                type: "success",
                message: "登录成功",
              });
              return;
            }
            this.$router.push('/');
            this.$message({
              type: "success",
              message: "登录成功",
            });
        }).catch(err=>{
          this.$router.push('/');
            this.$message({
              type: "success",
              message: "登录成功",
            });
        });
    },
  },
  computed: {
    checkPassNew() {
      return this.ruleForm2.checkPass;
    },
  },
  mounted() {
    const storedUsername = localStorage.getItem('username');
    const storedPassword = localStorage.getItem('password');
    if (storedUsername && storedPassword) {
      this.ruleForm2.account = storedUsername;
      this.ruleForm2.checkPass = storedPassword;
    }
    this.groupCode = sessionStorage.getItem('groupCode','');
    sessionStorage.removeItem("currentIndex");
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    sessionStorage.setItem("screenHeight", Number(window.screen.height));
  },
  created() {
    var _self = this;
    document.onkeydown = function (e) {
      if (window.event == undefined) {
        var key = e.keyCode;
      } else {
        var key = window.event.keyCode;
      }
      if (key == 13) {
        _self.enterLogin("ruleForm2");
      }
    };
  },
  components: { IdentifyCode },
};
</script>

<style lang="scss" scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 全屏背景渐变 */
.bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(140deg, #0A6EBD 0%, #1395DB 45%, #1BA8E5 75%, #24B8ED 100%);
  z-index: 1;
}

/* 光晕效果 */
.glow-center {
  position: absolute;
  top: -35%;
  left: -15%;
  width: 105%;
  height: 135%;
  background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%);
  z-index: 2;
}

.glow-right {
  position: absolute;
  top: 10%;
  right: -10%;
  width: 52%;
  height: 85%;
  background: radial-gradient(circle, rgba(10,90,144,0.19) 0%, rgba(10,90,144,0) 70%);
  z-index: 2;
}

.glow-1 {
  position: absolute;
  top: 17%;
  left: 7%;
  width: 35%;
  height: 56%;
  background: radial-gradient(circle, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 70%);
  opacity: 0.8;
  z-index: 2;
}

.glow-2 {
  position: absolute;
  top: 50%;
  left: 31%;
  width: 28%;
  height: 45%;
  background: radial-gradient(circle, rgba(36,184,237,0.21) 0%, rgba(36,184,237,0) 70%);
  opacity: 0.7;
  z-index: 2;
}

.glow-3 {
  position: absolute;
  top: 6%;
  right: 0;
  width: 31%;
  height: 50%;
  background: radial-gradient(circle, rgba(10,110,189,0.19) 0%, rgba(10,110,189,0) 70%);
  opacity: 0.9;
  z-index: 2;
}

/* 放射光线 */
.ray {
  position: absolute;
  width: 2px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0) 100%);
  z-index: 3;
}

.ray-1 {
  top: -11%;
  left: 14%;
  height: 45%;
  transform: rotate(15deg);
  opacity: 0.6;
}

.ray-2 {
  top: -6%;
  left: 35%;
  height: 39%;
  width: 1.5px;
  transform: rotate(-10deg);
  opacity: 0.5;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.12) 50%, rgba(255,255,255,0) 100%);
}

.ray-3 {
  top: -9%;
  right: 23%;
  height: 42%;
  transform: rotate(20deg);
  opacity: 0.7;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.18) 50%, rgba(255,255,255,0) 100%);
}

/* 装饰圆点 */
.dot {
  position: absolute;
  border-radius: 50%;
  z-index: 3;
}

.dot-1 {
  top: 20%;
  left: 5.5%;
  width: 8px;
  height: 8px;
  background: rgba(255,255,255,0.5);
  box-shadow: 0 0 12px rgba(255,255,255,0.6);
}

.dot-2 {
  top: 13%;
  left: 45%;
  width: 6px;
  height: 6px;
  background: rgba(255,255,255,0.45);
  box-shadow: 0 0 10px rgba(255,255,255,0.5);
}

.dot-3 {
  bottom: 28%;
  left: 14%;
  width: 10px;
  height: 10px;
  background: rgba(255,255,255,0.4);
  box-shadow: 0 0 16px rgba(255,255,255,0.5);
}

.dot-4 {
  bottom: 17%;
  left: 40%;
  width: 6px;
  height: 6px;
  background: rgba(255,255,255,0.35);
  box-shadow: 0 0 10px rgba(255,255,255,0.4);
}

.dot-5 {
  bottom: 28%;
  right: 23%;
  width: 8px;
  height: 8px;
  background: rgba(10,110,189,0.6);
  box-shadow: 0 0 14px rgba(10,110,189,0.5);
}

.dot-6 {
  top: 22%;
  right: 10%;
  width: 6px;
  height: 6px;
  background: rgba(10,110,189,0.55);
  box-shadow: 0 0 12px rgba(10,110,189,0.45);
}

/* 波浪效果 */
.wave {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 4;
}

.wave-1 {
  bottom: 0;
  height: 22%;
}

.wave-2 {
  bottom: 0;
  height: 17%;
}

.wave-3 {
  bottom: 0;
  height: 9%;
}

.wave-4 {
  bottom: 0;
  height: 4.5%;
}

/* 内容容器 */
.content-container {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
}

/* 左侧品牌区 */
.left-brand {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 26px;
  padding: 0 8% 10% 8%;
}

.logo-row {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.15));
}

.logo-text {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 5px;
}

.title-block {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.main-title {
  color: #FFFFFF;
  font-size: clamp(36px, 4vw, 56px);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.5px;
  margin: 0;
}

.tagline {
  color: rgba(255,255,255,0.82);
  font-size: 16px;
  letter-spacing: 16px;
  margin: 0;
}

.desc {
  color: rgba(255,255,255,0.58);
  font-size: 15px;
  line-height: 2.1;
  margin: 0;
}

.pill-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(255,255,255,0.16);
  border: 1px solid rgba(255,255,255,0.31);
  border-radius: 100px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(255,255,255,0.15);
  
  i {
    font-size: 16px;
  }
}

/* 右侧登录卡片 */
.right-login {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5%;
}

.login-card {
  position: relative;
  width: 100%;
  max-width: clamp(340px, 26vw, 400px);
  background: #FFFFFF;
  border-radius: 36px;
  padding: 52px 44px 44px;
  box-shadow: 
    0 50px 120px rgba(11,111,173,0.15),
    0 20px 60px rgba(11,111,173,0.08),
    0 1px 4px rgba(0,0,0,0.03),
    inset 0 0 0 1px rgba(255,255,255,0.4);
}

.card-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 250px;
  background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 100%);
  border-radius: 36px 36px 0 0;
  pointer-events: none;
}

.card-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 40px;
}

.card-logo-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  filter: drop-shadow(0 6px 20px rgba(19,149,219,0.2));
}

.card-title {
  color: #1D2129;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.card-subtitle {
  color: #86909C;
  font-size: 12px;
  letter-spacing: 0.3px;
  margin: 0;
}

.login-form {
  position: relative;
  
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
  
  ::v-deep .el-input__inner {
    height: 48px;
    line-height: 48px;
    padding-left: 44px;
    padding-right: 16px;
    border-radius: 12px;
    background: #F7F8FA;
    border: 1px solid #E5E6EB;
    font-size: 14px;
    color: #1D2129;
    transition: all 0.3s;
    
    &::placeholder {
      color: #86909C;
    }
    
    &:hover {
      border-color: #C9CDD4;
    }
    
    &:focus {
      background: #FFFFFF;
      border-color: #1395DB;
      box-shadow: 0 0 0 2px rgba(19,149,219,0.1);
    }
  }
  
  ::v-deep .el-input__prefix {
    left: 16px;
    
    i {
      color: #4E5969;
      font-size: 16px;
      line-height: 48px;
    }
  }
  
  ::v-deep .el-input__suffix {
    right: 16px;
    
    i {
      color: #86909C;
      font-size: 16px;
      line-height: 48px;
    }
  }
}

.code-row {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
}

.code-input {
  flex: 1;
  min-width: 0;
  
  ::v-deep .el-input__inner {
    padding-left: 16px !important;
  }
}



.login-btn-item {
  margin-bottom: 0;
}

.login-btn {
  width: 100%;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(180deg, #1BA8E5 0%, #1395DB 50%, #0E7FC0 100%);
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 5px;
  box-shadow: 
    0 8px 24px rgba(19,149,219,0.25),
    0 2px 6px rgba(19,149,219,0.13);
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 12px 32px rgba(19,149,219,0.3),
      0 4px 8px rgba(19,149,219,0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.card-footer {
  margin-top: 12px;
  text-align: center;
  
  p {
    color: #C9CDD4;
    font-size: 11px;
    margin: 0;
  }
}

/* 响应式布局 */
@media (max-width: 1024px) {
  .left-brand {
    display: none;
  }
  
  .right-login {
    width: 100%;
  }
  
  .login-card {
    max-width: clamp(360px, 80vw, 460px);
  }
}

@media (max-width: 768px) {
  .login-card {
    max-width: 100%;
    padding: 40px 32px 36px;
    border-radius: 28px;
  }
  
  .card-title {
    font-size: 24px;
  }
  
  .card-logo-img {
    width: 48px;
    height: 48px;
  }
}
</style>
